// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"74621444","787":"ca3c3cb2","850":"f716f878"}[chunkId] + ".chunk.js";
};